/**
 * ChangePlanModal - Modal for changing user plan
 */
export default function ChangePlanModal({
  show,
  onClose,
  newPlan,
  setNewPlan,
  newCycle,
  setNewCycle,
  planReason,
  setPlanReason,
  onChangePlan,
  loading,
  isBulk = false,
  selectedCount = 0,
}) {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-[60] flex items-center justify-center p-4">
      <div className="bg-card border border-border rounded-xl max-w-md w-full p-6 space-y-4">
        <h3 className="text-xl font-bold text-foreground">
          {isBulk ? `Change Plan for ${selectedCount} Users` : "Change Plan"}
        </h3>
        <select
          value={newPlan}
          onChange={(e) => setNewPlan(e.target.value)}
          className="w-full px-4 py-2 bg-muted border border-border rounded-lg text-foreground focus:outline-none focus:ring-2 focus:ring-primary"
        >
          <option value="free">Free</option>
          <option value="starter">Starter</option>
          <option value="pro">Pro</option>
          <option value="org">Organization</option>
        </select>
        {newPlan !== "free" && (
          <select
            value={newCycle}
            onChange={(e) => setNewCycle(e.target.value)}
            className="w-full px-4 py-2 bg-muted border border-border rounded-lg text-foreground focus:outline-none focus:ring-2 focus:ring-primary"
          >
            <option value="monthly">Monthly</option>
            <option value="annual">Annual</option>
          </select>
        )}
        <input
          type="text"
          placeholder="Reason for change"
          value={planReason}
          onChange={(e) => setPlanReason(e.target.value)}
          className="w-full px-4 py-2 bg-muted border border-border rounded-lg text-foreground placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-primary"
        />
        {isBulk && (
          <div className="bg-blue-500/10 border border-blue-500/20 rounded-lg p-3">
            <p className="text-blue-400 text-sm">
              All {selectedCount} users will be changed to <strong className="capitalize">{newPlan}</strong> plan
            </p>
          </div>
        )}
        <div className="flex gap-3">
          <button
            onClick={onChangePlan}
            disabled={loading}
            className="flex-1 px-4 py-2 bg-blue-600 hover:bg-blue-700 disabled:opacity-50 text-foreground rounded-lg transition"
          >
            {loading ? "Processing..." : isBulk ? "Change All Plans" : "Change Plan"}
          </button>
          <button
            onClick={onClose}
            className="flex-1 px-4 py-2 bg-muted hover:bg-slate-600 text-foreground rounded-lg transition"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
